import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

export interface Props {
  totalTimeOffPoolsMinutes: number
}

const ReservedForTimeOff = ({ totalTimeOffPoolsMinutes }: Props) => {
  return (
    <Box
      gap="s6"
      alignItems="center"
      flexDirection="row"
      width="full"
      justifyContent="spaceBetween"
    >
      <Text size="200" color="grey1000">
        {i18n.t('clock_in.sidepanel.balance.reserved_for_timeoff')}
      </Text>
      <Box flexDirection="row" gap="s2">
        <MinutesToText color="grey1000" value={totalTimeOffPoolsMinutes} size="200" />
      </Box>
    </Box>
  )
}

export default ReservedForTimeOff
